module.exports = __webpack_public_path__ + "img/marketing.c08782e0.svg";